module.exports = ":host.datetimepicker__input.ng-invalid.ng-touched .form__input {\n  border-color: #c44545; }\n  :host.datetimepicker__input.ng-invalid.ng-touched .form__input:focus {\n    border-color: #c44545;\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset, 0 0 3px #c44545; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/date-time-picker/date-time-picker.scss
// module id = zPrA
// module chunks = 12